// extracted by mini-css-extract-plugin
export default {"Container":"Signup_Container__YzA8j","ButtonContainer":"Signup_ButtonContainer__2Kf8q","Button":"Signup_Button__SRZB-"};